// // ** React Imports
// import { Navigate } from 'react-router-dom'
// import { Suspense, useEffect } from 'react'

// // ** Context Imports
// import { useDispatch, useSelector } from 'react-redux'

// import jwt_decode from 'jwt-decode'
// import axios from 'axios'
// import { logout } from '../../../redux/requests/auth'

// const PrivateRoute = ({ children, route }) => {
// 	const dispatch = useDispatch()

// 	const { isSuccess } = useSelector((state) => state.auth.login)
// 	const token = useSelector((state) => state.auth.login.data?.token)

// 	if (route) {
// 		useEffect(() => {
// 			checkTokenValid()
// 		})

// 		const checkTokenValid = async () => {
// 			if (!token) return logout(dispatch)
// 			else {
// 				try {
// 					const response = await axios.post(
// 						'/user/auth/check-login',
// 						{ token },
// 						{
// 							headers: { Authorization: `Bearer ${token}` }
// 						}
// 					)
// 					if (response.data !== 'OK') {
// 						logout(dispatch)
// 					}
// 				} catch (error) {
// 					logout(dispatch)
// 				}
// 			}
// 		}

// 		try {
// 			const decodedToken = jwt_decode(token)
// 			const currentTime = Date.now() / 1000 // Convert current time to seconds

// 			if (decodedToken.isBlock == 1) logout(dispatch)
// 			if (decodedToken.exp < currentTime) {
// 				logout(dispatch)
// 			}
// 		} catch (error) {
// 			logout(dispatch)
// 		}

// 		if (!token) window.location.href = '/login'

// 		if (!isSuccess) {
// 			return <Navigate to="/login" />
// 		}
// 	}

// 	return <Suspense fallback={null}>{children}</Suspense>
// }

// export default PrivateRoute

// ** React Imports
import { Navigate } from 'react-router-dom'
import { Suspense, useEffect } from 'react'

// ** Context Imports
import { useDispatch, useSelector } from 'react-redux'

import jwt_decode from 'jwt-decode'
import axios from 'axios'
import { logout } from '../../../redux/requests/auth'

const PrivateRoute = ({ children, route }) => {
	const dispatch = useDispatch()

	const { isSuccess } = useSelector((state) => state.auth.login)
	const token = useSelector((state) => state.auth.login.data?.token)

	if (route) {
		useEffect(() => {
			//checkTokenValid()
		})

		const checkTokenValid = async () => {
			if (!token) return logout(dispatch)
			else {
				try {
					const response = await axios.post(
						'/user/auth/check-login',
						{ token },
						{
							headers: { Authorization: `Bearer ${token}` }
						}
					)
					if (response.data !== 'OK') {
						logout(dispatch)
					}
				} catch (error) {
					logout(dispatch)
				}
			}
		}

		if (!token) window.location.href = '/login'

		if (!isSuccess) {
			return <Navigate to="/login" />
		}
	}

	return <Suspense fallback={null}>{children}</Suspense>
}

export default PrivateRoute
